import { Routes, Route } from 'react-router-dom'
import { LandingPage } from './pages/LandingPage'
import { Login } from './pages/Login'
import { Dashboard } from './pages/Dashboard'
import { Profile } from './pages/Profile'
import { SubscriptionManagement } from './pages/SubscriptionManagement'
import { UsageTracking } from './pages/UsageTracking'
import { OrganizationSettings } from './pages/OrganizationSettings'
import { NotFound } from './pages/NotFound'
import { BLISDemo } from './pages/BLISDemo'
import { IZGDemo } from './pages/IZGDemo'
import { TermsAndConditions } from './pages/TermsAndConditions'
import { PrivacyPolicy } from './pages/PrivacyPolicy'
import { ContactUs } from './pages/ContactUs'
import { ProtectedRoute, ScrollToTop } from './components/layout'
import { useAuth } from './hooks/useAuth'
import { ToastProvider } from './contexts/ToastContext'

function App() {
  const { isAuthenticated } = useAuth()

  return (
    <ToastProvider>
      <ScrollToTop />
      <Routes>
      {/* Public Routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/services/blis/demo" element={<BLISDemo />} />
      <Route path="/services/izg/demo" element={<IZGDemo />} />
      <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/contact-us" element={<ContactUs />} />

      {/* Protected Routes */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <Profile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/subscriptions"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <SubscriptionManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/usage"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <UsageTracking />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/organization"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <OrganizationSettings />
          </ProtectedRoute>
        }
      />

      {/* 404 Page */}
      <Route path="*" element={<NotFound />} />
    </Routes>
    </ToastProvider>
  )
}

export default App


